import { render } from "./CountToDemo.vue?vue&type=template&id=584ad6ae&scoped=true"
import script from "./CountToDemo.vue?vue&type=script&lang=ts"
export * from "./CountToDemo.vue?vue&type=script&lang=ts"

import "./CountToDemo.vue?vue&type=style&index=0&id=584ad6ae&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-584ad6ae"

export default script